import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import roles from '@clearscore/constants.role-statuses';
import useMedia from '@clearscore/hooks.use-media';
import breakpoints from '@bond/breakpoints';
import getEnv from '@clearscore/helpers.envs';
import ClearScoreLogoNoText from '@clearscore/icons.clearscore-logo-no-text-rainbow';
import ClearScoreLogoWithText from '@clearscore/icons.clearscore-logo-with-text-rainbow';
import { selectors as sessionSelectors } from '@clearscore/redux.session';

import styles from './logo-navigation.css';

const logoNoText = () => (
    <div className={styles.logoNoText}>
        <ClearScoreLogoNoText />
    </div>
);

const logoWithText = () => (
    <div className={styles.logoWithText}>
        <ClearScoreLogoWithText />
    </div>
);

const LogoNavigation = ({ progressIndicatorEnabled }) => {
    const role = useSelector(sessionSelectors.getAuthRole);
    const isMediumViewport = useMedia([null, breakpoints.m], [false, true]);
    const showLogoText = isMediumViewport || !progressIndicatorEnabled;
    const Logo = showLogoText ? logoWithText : logoNoText;

    return (
        <div className={cx(styles.logoNavigation, { [styles.logoNavigationHeaderHidden]: !progressIndicatorEnabled })}>
            <Choose>
                <When condition={role === roles.AUTHORISED}>
                    <NavLink to="/">
                        <Logo />
                    </NavLink>
                </When>

                <When condition={getEnv('WEBVIEW')}>
                    <Logo />
                </When>

                <Otherwise>
                    <a href={getEnv('INTERNATIONAL_WEBSITE')}>
                        <Logo />
                    </a>
                </Otherwise>
            </Choose>
        </div>
    );
};

LogoNavigation.propTypes = {
    progressIndicatorEnabled: PropTypes.bool,
};

LogoNavigation.defaultProps = {
    progressIndicatorEnabled: true,
};

export default LogoNavigation;
